import { Translate } from '@change-corgi/core/react/i18n';
import { Card, Separator } from '@change-corgi/design-system-legacy/components/content';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../hooks/useDashboardReskinExperiment';
import { ExportButton } from '../../shared/ExportButton';
import { useExportButton } from '../../shared/ExportButton/hooks/useExportButton';
import { ExportNotifications } from '../components/ExportNotifications';
import { PageBody } from '../components/PageBody';

import { Layout as LayoutNew } from './index_new';

export const Layout: React.FC<Props> = ({ setCommentsVisibility }) => {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	const { data, actions } = useExportButton('comments');

	if (isEnabled) {
		return <LayoutNew setCommentsVisibility={setCommentsVisibility} />;
	}

	return (
		<Card
			as="section"
			backgroundColor="white"
			sx={{
				border: 'unset',
				display: 'flex',
				flexDirection: 'column',
				borderRadius: 'big',
				position: 'relative',
				mb: '16px',
			}}
			data-qa="starter-dashboard-comments-card"
			data-testid="starter-dashboard-comments-card"
			aria-label="export-comments-card"
			aria-describedby="export-comments-card"
		>
			<Flex id="petition-comments-card-header" p="24px 24px 16px" sx={{ alignItems: 'center', gap: 4, height: '84px' }}>
				<Box sx={{ minWidth: '200px', maxWidth: '200px' }}>
					<Heading
						as="h3"
						size="h4"
						id="comments-card-header"
						data-qa="comments-card-header-heading"
						data-testid="comments-card-header-heading"
						aria-label="export-comments-header-heading"
						aria-describedby="export-comments-header-heading"
					>
						<Translate value="corgi.petition.starter_dashboard.petition_comments.card.header" />
					</Heading>
				</Box>
				<Box sx={{ ml: 'auto', justifySelf: 'end' }}>
					<ExportButton
						data-qa="export-signatures-button"
						aria-label="export-comments-button"
						aria-describedby="export-comments-button"
						exportType="COMMENTS"
						data={data}
						actions={actions}
					/>
				</Box>
			</Flex>
			<Separator />
			<PageBody setCommentsVisibility={setCommentsVisibility} />
			<ExportNotifications data={data} />
		</Card>
	);
};

type Props = Readonly<{
	setCommentsVisibility: (visible: boolean) => void;
}>;
